import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 3.5 5.5 6l-.884-.884L8 1.732l3.384 3.384L10.5 6zm0 9L5.5 10l-.884.884L8 14.268l3.384-3.384L10.5 10z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }